exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".donation-form[data-v-e0075c96]{padding:15px 0}.donation-form[data-v-e0075c96]  .form-row>.mb-2{width:100%}.donation-form[data-v-e0075c96]  .form-row>.mb-2:last-of-type{text-align:right}.donation-form[data-v-e0075c96]  .form-row input.form-control,.donation-form[data-v-e0075c96]  .form-row select.custom-select{width:100%;max-width:100%!important;margin-bottom:1.2rem}", ""]);

// exports
